import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

import Photos from '../../../lib/Photos'
import {jsonResponseHandler} from "../../../utils/FetchHelper"
import Thumbnail from "../../../lib/Thumbnail"
import { connect } from "react-redux";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({}), dispatch => ({
    dispatch
}))
class BlogLogoForm extends Component {

	constructor() {
		super()
		this.state = {
			uploading: false
		}
	}

	@autobind
	handleUpload() {
		const { onChange } = this.props
		const { logoFile } = this.refs
		let files = logoFile.files

		if (files.length === 0) {
			return
		}

		let file = logoFile.files[0]
		if (file.size > 2000000) {
			alert("파일 사이즈가 너무 큽니다. 2MB 이하의 파일을 사용해주세요.")
			return
		}

		this.uploadLogo(files[0]).then(url => {
			if (!url) {
				return
			}
			Photos.getInstance().open(url, file => {
				this.uploadLogo(file).then(url => {
					if (!url) {
						return
					}
					onChange(url)
				})
			})
		})
	}

	@autobind
	uploadLogo(file) {
		const { dispatch } = this.props;
		const { logoFile } = this.refs
		let formdata = new FormData()
		formdata.append("files[]", file, file.name)

		this.setState({
			uploading: true
		})

		return fetch(addPrefix("/manage/setting/blog/logo.json"), {
			method: 'post',
			credentials: "include",
			body: formdata
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				logoFile.value = ''
				this.setState({
					uploading: false
				})
				return data.url
			})
			.catch(e => {
				console.error(e)
				alert("이미지를 업로드하지 못했습니다.")
				logoFile.value = ''
				this.setState({
					uploading: false
				})
			})
	}

	render() {
		const { uploading } = this.state
		const { logo, onDelete } = this.props

		return (
			<fieldset className="fld_image">
				<legend className="screen_out">블로그 이미지 설정</legend>

				{ uploading &&
					<div className="wrap_thumb photo_profile photo_loading">
						<span className="ico_blog ico_loading"/>
					</div>
				}

				{ !uploading &&
					<div className="wrap_thumb photo_profile">

						{ logo &&
						<img src={Thumbnail.make('C360x360', logo)} className="thumb_img" width="180" height="180" alt="" />
						}

            <label className="lab_btn lab_photo">
              <span className="ico_blog">블로그 이미지 찾아보기</span>
              <input ref="logoFile" type="file" className="btn_g" accept="image/*" onChange={this.handleUpload} />
            </label>

						{ logo &&
            <button type="button" className="btn_delete" onClick={onDelete}>이미지 삭제</button>
						}
					</div>
				}

			</fieldset>
		)
	}
}

BlogLogoForm.propTypes = {
	logo: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	onDelete: PropTypes.func
}

export default BlogLogoForm
